export const PRICE_DISPLAY_OPTIONS = {
    NIGHTLY_PRICE_ONLY: 'showNightlyPrice',
    TOTAL_PRICE_ONLY: 'showTotalPrice',
    BOTH_PRICES_TOTAL_FIRST: 'showBoth#Total',
    BOTH_PRICES_NIGHTLY_FIRST: 'showBoth#Nightly'
};

export const PRICE_DISPLAY_TAX_FEE_OPTIONS = {
    INCLUDE_TAXES_FEES: 'includeTaxesFees',
    EXCLUDE_TAXES_FEES: 'excludeTaxesFees',
    INCLUDE_FEES_ONLY: 'includeFeesOnly'
}


// WEBPACK FOOTER //
// ./src/constants/PricingDisplay.js